import { useUnpublishPreview } from "../../../hooks/useUnpublishPreview";
import { buildUnpublishConsequences } from "../../../lib/unpublish-consequences";

export interface UnpublishConsequencesProps {
  getToken: () => Promise<string | null>;
  /** The dialog's open state — the preflight runs only while true. */
  enabled: boolean;
  /** Four-state publish block state 4: an active marketplace connection.
   * Unpublishing never ends it; the copy points at Disconnect instead. */
  connected: boolean;
}

/**
 * UnpublishConsequences is the body of the unpublish confirm dialog (M11-B2,
 * plan 325, task 1460 — M6-C consent-sheet idiom): it lists what leaving the
 * market will do, with counts from the backend preflight. The copy is pure
 * (`lib/unpublish-consequences.ts`); this component only fetches and renders.
 */
export function UnpublishConsequences({
  getToken,
  enabled,
  connected,
}: UnpublishConsequencesProps) {
  const { preview, status } = useUnpublishPreview({ getToken, enabled });
  const lines = buildUnpublishConsequences({ preview, status, connected });
  return (
    <ul
      className="list-disc space-y-1.5 pl-5 text-base leading-relaxed text-foreground"
      data-testid="unpublish-consequences"
      aria-busy={status === "loading"}
    >
      {lines.map((line) => (
        <li key={line}>{line}</li>
      ))}
    </ul>
  );
}
